import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import { ShowAppBar } from "../../Redux/Action";
import { setJsonData } from "../../Redux/Action";
import { useEffect } from "react";
import { fetchIndicatorData } from "../Services/api";
import { GetColor } from "./constant";
import { CircularProgress } from "@mui/material";

const EMA = (props) => {
  const [showdetails, setShowDetails] = useState(false);
  const [selectedTick, setselectedTick] = useState(null);
  const jsonData = useSelector((state) => state.jsonData);
  const selectIndicator = useSelector((state) => state.SelectedDropdownOption);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const serachValue = useSelector((state) => state.searchvalue);
  const [filterData, setfilterData] = useState(null);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectIndicator === "EMA") {
      fetchIndicatorData(
        selecttimeFrame,
        selectedExchange,
        dispatch,
        setJsonData
      );
    }
  }, [selecttimeFrame, selectedExchange, selectIndicator, dispatch]);
  // const jsonData = {
  //   Exchange: "NSE",
  //   BarType: "Daily",
  //   Segment: "NSECASH",
  //   IndicatorDate: "2024-05-16T00:00:00",
  //   MADate: "2024-05-16T00:00:00",
  //   Data: [
  //     {
  //       Ticker: "20MICRONS",
  //       Overall: {
  //         Summary: "StrongBuy",
  //         SummaryPercent: 83.3,
  //       },
  //       IndicatorSummary: {
  //         Summary: "StrongBuy",
  //         SummaryPercent: 66.64,
  //       },
  //       SMASummary: {
  //         Summary: "StrongBuy",
  //         SummaryPercent: 99.96,
  //       },
  //       EMASummary: {
  //         Summary: "StrongBuy",
  //         SummaryPercent: 99.96,
  //       },
  //       OverallMASummary: {
  //         Summary: "StrongBuy",
  //         SummaryPercent: 99.96,
  //       },
  //       IndicatorResults: [
  //         {
  //           Indicator: "Rsi",
  //           Value: 71.707,
  //           Indication: "OverBought",
  //         },
  //         {
  //           Indicator: "ADX",
  //           Value: 19.7131,
  //           Indication: "Neutral",
  //         },
  //         {
  //           Indicator: "BollingerBands",
  //           Value: 1.0414,
  //           Indication: "OverBought",
  //         },
  //         {
  //           Indicator: "MACD",
  //           Value: 4.8551,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "Stoch",
  //           Value: 75.0209,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "StochRsi",
  //           Value: 59.391,
  //           Indication: "Buy",
  //         },
  //       ],
  //       SMAResults: [
  //         {
  //           Indicator: "SMA5",
  //           Value: 174.74,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA8",
  //           Value: 171.775,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA10",
  //           Value: 171.865,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA20",
  //           Value: 166.09,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA50",
  //           Value: 155.644,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA100",
  //           Value: 160.836,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA200",
  //           Value: 151.1712,
  //           Indication: "Sell",
  //         },
  //       ],
  //       EMAResults: [
  //         {
  //           Indicator: "EMA5",
  //           Value: 178.5421,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA8",
  //           Value: 175.0289,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA10",
  //           Value: 173.391,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA20",
  //           Value: 167.7416,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA50",
  //           Value: 161.1366,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA100",
  //           Value: 157.7816,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA200",
  //           Value: 146.8236,
  //           Indication: "Sell",
  //         },
  //       ],
  //     },
  //     {
  //       Ticker: "21STCENMGM",
  //       Overall: {
  //         Summary: "Sell",
  //         SummaryPercent: -42.245,
  //       },
  //       IndicatorSummary: {
  //         Summary: "Sell",
  //         SummaryPercent: -41.65,
  //       },
  //       SMASummary: {
  //         Summary: "Sell",
  //         SummaryPercent: -42.84,
  //       },
  //       EMASummary: {
  //         Summary: "Sell",
  //         SummaryPercent: -42.84,
  //       },
  //       OverallMASummary: {
  //         Summary: "Sell",
  //         SummaryPercent: -42.84,
  //       },
  //       IndicatorResults: [
  //         {
  //           Indicator: "Rsi",
  //           Value: 34.9737,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "ADX",
  //           Value: 25.707,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "BollingerBands",
  //           Value: -0.072,
  //           Indication: "OverSold",
  //         },
  //         {
  //           Indicator: "MACD",
  //           Value: 0.6936,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "Stoch",
  //           Value: 0.8264,
  //           Indication: "OverSold",
  //         },
  //         {
  //           Indicator: "StochRsi",
  //           Value: 0.0,
  //           Indication: "OverSold",
  //         },
  //       ],
  //       SMAResults: [
  //         {
  //           Indicator: "SMA5",
  //           Value: 47.51,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "SMA8",
  //           Value: 48.97499,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "SMA10",
  //           Value: 49.79,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "SMA20",
  //           Value: 50.89501,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "SMA50",
  //           Value: 47.96399,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "SMA100",
  //           Value: 43.9895,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "SMA200",
  //           Value: 32.32225,
  //           Indication: "Sell",
  //         },
  //       ],
  //       EMAResults: [
  //         {
  //           Indicator: "EMA5",
  //           Value: 47.41666,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "EMA8",
  //           Value: 48.34219,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "EMA10",
  //           Value: 48.7499,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "EMA20",
  //           Value: 49.36337,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "EMA50",
  //           Value: 47.80467,
  //           Indication: "Buy",
  //         },
  //         {
  //           Indicator: "EMA100",
  //           Value: 43.29986,
  //           Indication: "Sell",
  //         },
  //         {
  //           Indicator: "EMA200",
  //           Value: 36.30828,
  //           Indication: "Sell",
  //         },
  //       ],
  //     },
  //   ],
  // };
  const handleShowDetails = (details) => {
    setselectedTick(details);
    setShowDetails(true);
    dispatch(ShowAppBar(true));
  };

  const handleShowDetails1 = () => {
    debugger;
    setselectedTick(null);
    setShowDetails(false);
    dispatch(ShowAppBar(false));
  };
  // Function to filter array data
  const filterArrayData = (dataArray) => {
    return dataArray.filter((item) =>
      item.Ticker.trim()
        .toLowerCase()
        .includes(serachValue.trim().toLowerCase())
    );
  };
  const filterObjectData = (dataObject) => {
    if (dataObject && dataObject.Data) {
      return dataObject.Data.filter(
        (item) =>
          serachValue &&
          item.Ticker &&
          item.Ticker.trim()
            .toLowerCase()
            .includes(serachValue.trim().toLowerCase())
      );
    }
    return [];
  };
  const getFilteredData = () => {
    debugger;
    if (!jsonData) {
      return [];
    }

    if (Array.isArray(jsonData)) {
      return filterArrayData(jsonData);
    } else if (typeof jsonData === "object") {
      return filterObjectData(jsonData);
    }

    return [];
  };

  useEffect(() => {
    if (serachValue === "") {
      setfilterData(jsonData.Data);
    } else {
      setfilterData(getFilteredData());
    }
  }, [jsonData, serachValue]);
  return (
    isLoading ? 
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'50vh'}}>
<CircularProgress/>

    </div>
    :
    <div>
      {!showdetails ? (
        <Card style={{ height: "100vh" }}>
          <CardContent
            style={{
              alignItems: "center",
              height: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "80",
                  fontWeight: "bold",
                  padding: "0px 0px 10px 0px",
                  position: "sticky",
                  top: "0",
                  color: "grey",
                  backgroundColor: "white",
                  zIndex: "1",
                }}
              >
                <div style={{ flex: "1" }}>Symbol</div>
                <div style={{ flex: "1" }}>Summary %</div>
              </div>
              <div style={{ flex: "1", overflowY: "auto" }}>
                {filterData &&
                  filterData.length !== 0 &&
                  filterData.map((values, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px",
                        borderBottom: "1px solid grey",
                        padding: "20px 0px 20px 0px",
                      }}
                    >
                      <div style={{ flex: "1" }}>{values.Ticker}</div>
                      {/* <div style={{ flex: "1" }}> {values.EMASummary.Summary}</div> */}
                      {/* <div style={{ flex: "1" }}>
                        {values.EMASummary.SummaryPercent}
                      </div> */}
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        <div
                          style={{
                            color: GetColor(values.EMASummary.Summary),
                          }}
                        >
                          {values.EMASummary.SummaryPercent}
                        </div>
                        <div>{values.EMASummary.Summary.toUpperCase()}</div>
                      </div>
                      <div onClick={() => handleShowDetails(values)}>
                        <ChevronRightIcon />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </CardContent>
        </Card>
      ) : null}

      {showdetails ? (
        <Card
          style={{
            border: "1px solid green",
            height: "99vh",
            overflowY: "auto",
          }}
        >
          <div>
            <div>
              <Button
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  fontSize: "medium",
                }}
                onClick={() => handleShowDetails1()}
              >
                Close
              </Button>
            </div>
          </div>
          <CardContent>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h3
                style={{
                  color: GetColor(selectedTick.SMASummary.Summary),
                }}
              >
                {selectedTick.Ticker}
              </h3>
            </div>
            <div
              style={{
                fontSize: "16px",
              }}
            >
              {selectedTick.EMAResults.map((values, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    margin: "10px",
                  }}
                >
                  <div style={{ textAlign: "left" }}>
                    <div> {values.Indicator.toUpperCase()}</div>
                    <div style={{ color: GetColor(values.Indication) }}>
                      {values.Indication.toUpperCase()}
                    </div>
                  </div>
                  <div style={{ color: GetColor(values.Indication) }}>
                    {values.Value}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default EMA;
